import { FunctionComponent } from 'react';

// components
import { PriceAmount } from './PriceAmount';

type Props = {
    price?: number;
    originalPrice?: number;
    percentageOff?: number;
    currency: string;
    quantityDisplay: string | null;
    hasPrivateOffer?: boolean;
    displayVatLabel?: boolean;
};

/**
 * Price Components for an item with a net price
 *  (Net or Net & Retail)
 */
export const NetItemPrices: FunctionComponent<Props> = ({
    price,
    originalPrice,
    currency,
    percentageOff,
    quantityDisplay,
    hasPrivateOffer,
    displayVatLabel,
}) => (
    <>
        {/* NET PRICE */}
        {!!price && (
            <PriceAmount
                type="NET"
                showLabel
                amount={price}
                currency={currency}
                quantityDisplay={quantityDisplay}
                hasPrivateOffer={hasPrivateOffer}
                displayVatLabel={displayVatLabel}
            />
        )}
        {/* RETAIL PRICE */}
        {!!originalPrice && !hasPrivateOffer && (
            <PriceAmount
                hasNetPrice
                discount={percentageOff}
                currency={currency}
                amount={originalPrice}
                quantityDisplay={quantityDisplay}
                hasPrivateOffer={hasPrivateOffer}
            />
        )}
    </>
);
